import {
  BaseResource,
  idObjectReferenceSerializer,
  ResourceAction,
  ResourceActionV2,
} from "@megarax/rest-resource";
import { Serializers } from "@megarax/serializers";

import { permissions } from "./permissions";

const list = ResourceAction({
  name: "list",
  method: "get",
  path: "",
  querySerializer: Serializers.object({
    searchTerm: Serializers.string,
  }),
  responseSerializer: Serializers.array(Serializers.string),
});

const authorizedUsersAction = ResourceActionV2({
  name: "authorizedUsers",
  method: "get",
  querySerializer: Serializers.object({
    permission: Serializers.stringOneOf(...permissions),
  }),
  responseValueSerializer: Serializers.array(idObjectReferenceSerializer),
});

export type { Permission } from "./permissions";
export const permissionResource = BaseResource(["iam", "permissions"], {
  list,
  accessibleServices: ResourceAction({
    name: "accessibleServices",
    method: "get",
    responseSerializer: Serializers.array(Serializers.string),
  }),
  authorizedUsers: authorizedUsersAction,
});
